export default __webpack_public_path__ + "static/media/bg-pattern-intro-left-desktop.3a425b38.svg";